"use client";

import { Plus, MessageCircle } from "lucide-react";
import { Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import type { FAQItem } from "./faq";

export interface PAASectionProps {
  id?: string;
  eyebrow: string;
  title: string;
  items: FAQItem[];
  accent: string;
}

export function PAASection({
  id = "paa",
  eyebrow,
  title,
  items,
  accent,
}: PAASectionProps) {
  return (
    <section id={id} className="relative section-pad">
      <Container>
        <Reveal className="text-center max-w-3xl mx-auto mb-10">
          <span
            className="inline-flex items-center gap-2 px-3 py-1 rounded-full glass eyebrow-tiny"
            style={{ color: accent }}
          >
            <MessageCircle className="h-3 w-3" />
            {eyebrow}
          </span>
          <h2 className="mt-5">{title}</h2>
        </Reveal>

        <div className="max-w-3xl mx-auto space-y-3">
          {items.map((f) => (
            <details
              key={f.q}
              className="glass rounded-2xl group"
              style={{ boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)` }}
            >
              <summary className="flex items-center justify-between gap-4 px-5 py-4 cursor-pointer list-none hover:bg-[rgb(var(--border)/0.04)] transition-colors rounded-2xl">
                <span className="font-semibold text-sm text-left">{f.q}</span>
                <Plus className="h-4 w-4 shrink-0 transition-transform group-open:rotate-45" style={{ color: accent }} />
              </summary>
              <div className="px-5 pb-5 -mt-1 text-sm text-[rgb(var(--fg-muted))] leading-relaxed">
                {f.a}
              </div>
            </details>
          ))}
        </div>
      </Container>
    </section>
  );
}
